import { Box, Skeleton, styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import times from 'lodash.times';

import { MAIN_CATEGORY_DESKTOP } from './constants';

const SkeletonMenuLinks = styled(Box)(({ theme }) => ({
  borderRight: `2px solid ${theme.palette.grey[100]}`,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(0, 2),
}));

const CATEGORIES_LINKS = 15;

export const SkeletonMainCategoriesDesktop = () => {
  const { getTestId } = useTestId();

  return (
    <Box
      data-testid={getTestId(MAIN_CATEGORY_DESKTOP)}
      sx={{ position: 'relative', width: '20vw' }}
    >
      <SkeletonMenuLinks>
        {times(CATEGORIES_LINKS, (index) => (
          <Skeleton
            key={`menu-main-links-${index}`}
            animation="wave"
            height={32}
          />
        ))}
      </SkeletonMenuLinks>
    </Box>
  );
};
